(() => {
  /**
   * Animate the background between light and dark states
   */
  class BackgroundAnimator extends PIXI.Container {
    constructor() {
      super();
      this.hasLoaded = false;

      this._bubblesPosition = {
        landscape: { x: 620, y: 360 },
        portrait: { x: 380, y: 720 },
      };
      this._fishLeftPosition = {
        landscape: { x: -30, y: 110 },
        portrait: { x: -30, y: 460 },
      };
      this._fishRightPosition = {
        landscape: { x: 1310, y: 110 },
        portrait: { x: 750, y: 460 },
      };
    }

    /**
     * Initialise the class
     */
    initialise() {
      messageBus.subscribe("spinner:GameConfigEvent", () => {
        this._onLayoutComplete();
      });
      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Once asset layout has complete then grab the assets
     */
    _onLayoutComplete() {
      const isLandscape = systemData.isLandscape;

      this._fishContainer = resourceManager.get(this.name + ":fishContainer");
      this._fishContainerBonus = resourceManager.get(this.name + ":fishContainerBonus");
      this._fishContainerBonus.alpha = 0;

      const bubblesPosition = isLandscape ? this._bubblesPosition.landscape : this._bubblesPosition.portrait;
      this._backgroundParticleEmitter = particleManager.createEmitter(
        "backgroundBubbles",
        this.name,
        bubblesPosition.x,
        bubblesPosition.y,
        false,
        bubblesPosition.scale
      );
      this._backgroundParticleEmitter.particleEmitter.emit = true;

      const fishLeftPosition = isLandscape ? this._fishLeftPosition.landscape : this._fishLeftPosition.portrait;
      this._fishLeftEmitter = particleManager.createEmitter(
        "backgroundFishLeft",
        this.name + ":fishContainer",
        fishLeftPosition.x,
        fishLeftPosition.y,
        false,
        fishLeftPosition.scale
      );
      this._fishLeftEmitterBonus = particleManager.createEmitter(
        "backgroundFishLeftBonus",
        this.name + ":fishContainerBonus",
        fishLeftPosition.x,
        fishLeftPosition.y,
        false,
        fishLeftPosition.scale
      );
      this._fishLeftEmitter.particleEmitter.emit = true;
      this._fishLeftEmitterBonus.particleEmitter.emit = true;

      const fishRightPosition = isLandscape ? this._fishRightPosition.landscape : this._fishRightPosition.portrait;
      this._fishRightEmitter = particleManager.createEmitter(
        "backgroundFishRight",
        this.name + ":fishContainer",
        fishRightPosition.x,
        fishRightPosition.y,
        false,
        fishRightPosition.scale
      );
      this._fishRightEmitterBonus = particleManager.createEmitter(
        "backgroundFishRightBonus",
        this.name + ":fishContainerBonus",
        fishRightPosition.x,
        fishRightPosition.y,
        false,
        fishRightPosition.scale
      );
      this._fishRightEmitter.particleEmitter.emit = true;
      this._fishRightEmitterBonus.particleEmitter.emit = true;

      this.hasLoaded = true;
    }

    toggleFreeSpins(freespins) {
      const duration = 2;

      if (freespins) {
        gsap.to(this._fishContainer, {
          duration,
          alpha: 0,
        });
        gsap.to(this._fishContainerBonus, {
          duration,
          alpha: 1,
        });

        //this._shipSpine.setSkin("ship_bonus");
      } else {
        gsap.to(this._fishContainer, {
          duration,
          alpha: 1,
        });
        gsap.to(this._fishContainerBonus, {
          duration,
          alpha: 0,
        });

        //this._shipSpine.setSkin("ship");
      }
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      if (this.hasLoaded) {
        const bubblesPosition = isLandscape ? this._bubblesPosition.landscape : this._bubblesPosition.portrait;
        this._backgroundParticleEmitter.x = bubblesPosition.x;
        this._backgroundParticleEmitter.y = bubblesPosition.y;

        const fishLeftPosition = isLandscape ? this._fishLeftPosition.landscape : this._fishLeftPosition.portrait;
        this._fishLeftEmitter.x = fishLeftPosition.x;
        this._fishLeftEmitter.y = fishLeftPosition.y;
        this._fishLeftEmitterBonus.x = fishLeftPosition.x;
        this._fishLeftEmitterBonus.y = fishLeftPosition.y;

        const fishRightPosition = isLandscape ? this._fishRightPosition.landscape : this._fishRightPosition.portrait;
        this._fishRightEmitter.x = fishRightPosition.x;
        this._fishRightEmitter.y = fishRightPosition.y;
        this._fishRightEmitterBonus.x = fishRightPosition.x;
        this._fishRightEmitterBonus.y = fishRightPosition.y;

        // TODO CM
        // const shipLandscape = { x: 490, y: 108 };
        // const shipPortrait = { x: 165, y: 515 };
        // const shipPos = isLandscape ? shipLandscape : shipPortrait;
        // this._shipSpine.position.set(shipPos);
      }
    }
  }

  resourceManager.registerObjectType(
    "backgroundAnimator",
    () => new BackgroundAnimator(),
    initialise,
    () => []
  );
})();
